import { render, staticRenderFns } from "./XSelect.vue?vue&type=template&id=75370c63&scoped=true"
import script from "./XSelect.vue?vue&type=script&lang=js"
export * from "./XSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75370c63",
  null
  
)

export default component.exports